import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react'
import type { CSSProperties } from 'react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

/*
 * Toast — feedback temporário de ação.
 *
 * O registry gov.br publica `notification`, que é outra coisa: o painel de
 * avisos acumulados que abre a partir do cabeçalho. O aviso efêmero que aparece
 * e some sozinho não tem item no registry, então ele continua vindo do `sonner`,
 * com as cores e a elevação lidas dos tokens do DS.
 *
 * Toast é feedback de estado: informação neutra e permanente é `Message`.
 * O tema é fixo em claro — o DS gov.br não define paleta escura.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-5 text-success" />,
        info: <InfoIcon className="size-5 text-info" />,
        warning: <TriangleAlertIcon className="size-5 text-warning" />,
        error: <OctagonXIcon className="size-5 text-danger" />,
        loading: <Loader2Icon className="size-5 animate-spin text-primary" />,
      }}
      style={
        {
          '--normal-bg': 'var(--background-light)',
          '--normal-text': 'var(--color)',
          '--normal-border': 'var(--border-color)',
          '--border-radius': 'var(--surface-rounder-sm)',
          '--box-shadow': 'var(--surface-shadow-md)',
        } as CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
